.spacer {
  flex: 1;
}
